import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { AppState } from './core/app.state';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { SetLanguage } from './shared/store/shared.actions';
import { Actions, ofType } from '@ngrx/effects';
import { LoginActionSuccess } from './features/auth/store/auth.actions';
import { Subject, takeUntil } from 'rxjs';
import { DateLocaleService } from './shared/services/date-locale.service';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/loader/loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [AsyncPipe, RouterOutlet, LoaderComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  private store = inject<Store<AppState>>(Store);
  private translateService = inject(TranslateService);
  private actions$ = inject(Actions);
  private dateLocaleService = inject(DateLocaleService);

  isAppLoading$ = this.store.select((state) => state.shared.isAppLoading);
  title = 'volta marketplace';

  destroy$ = new Subject<void>();

  constructor() {
    // Set the language from the local storage if it exists
    const lang = localStorage.getItem('lang');

    if (lang) {
      this.translateService.use(lang);
      this.store.dispatch(SetLanguage({ language: lang }));
      this.dateLocaleService.setLocale(lang);
    } else {
      this.translateService.setFallbackLang('en');
      this.dateLocaleService.setLocale('en');
    }
  }

  ngOnInit(): void {
    this.actions$.pipe(ofType(LoginActionSuccess), takeUntil(this.destroy$)).subscribe((action) => {
      const lang = action.payload.object.contact.lang.split('_')[0] || 'en';

      this.translateService.use(lang);
      localStorage.setItem('lang', lang);
      this.store.dispatch(SetLanguage({ language: lang }));
      this.dateLocaleService.setLocale(lang);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
